import React from 'react';
import { Outlet } from 'react-router-dom';

const ManageProductAndService = () => {
  return <Outlet />;
};

export default ManageProductAndService;
